import { useDispatch, useSelector } from 'react-redux';
import {
  fetchGetInventory,
  fetchPostInventory,
  fetchPutInventory,
  fetchDeleteInventory,
  cleanUpInventory,
  cleanUpMessageInventory
} from 'state-managament/inventory.slice';

export default function useInventory(project) {
  const { error, success, isLoaded, data } = useSelector((state) => state.inventory);
  const dispatch = useDispatch();

  const cleanUp = () => dispatch(cleanUpInventory());
  const cleanUpMessage = () => dispatch(cleanUpMessageInventory());
  const getInventory = (args) => dispatch(fetchGetInventory(args));
  const postInventory = (args) => dispatch(fetchPostInventory(args));
  const deleteInventory = (args) => dispatch(fetchDeleteInventory(args));
  const putInventory = (args) => dispatch(fetchPutInventory(args));

  return {
    error,
    success,
    isLoaded,
    data,
    cleanUp,
    cleanUpMessage,
    getInventory,
    postInventory,
    deleteInventory,
    putInventory,
  };

}
